import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService} from "@ngx-translate/core";
import { Subject } from 'rxjs/Subject';
import { MainStoreService } from '@nw/ui-core-shared/store/main-store.service';
import { HelpMenuService } from '@nw/ui-core-shared/services/help-menu.service';
import {PlatformLocation} from '@angular/common';
const introJs = require('intro.js');

@Component({
    selector   : 'first-time-wl-user-tutorials-v1',
    templateUrl: './first-time-wl-user-tutorials-v1.component.html',
    providers: [Subject]
})

export class FirstTimeWlUserTutorialsV1Component implements OnInit, OnChanges {
    currentPageTutorialName: string = 'watchlist';
    completedTutorials: string[];
    tutorialTranslation: any = undefined;
    tutorialsToComplete: string[] = undefined;
    tutorialStateObject: { isTutorialEscaped: boolean; tutorialsCompleted: string[]; language: string;} = {
        isTutorialEscaped: false, tutorialsCompleted: undefined, language: undefined};
    tutorialLang: string;
    plId: string | number;
    @Input() ifWLHasVehicles;

    constructor(
        private translateService: TranslateService,
        private mainStoreService: MainStoreService,
        private helpMenuService: HelpMenuService,
        private location: PlatformLocation,
        public tutorialState: Subject<{
            isTutorialEscaped: boolean;
            tutorialsCompleted: string[];
            language: string;}>
    ) {
        mainStoreService.getStore().select(state => state.appPrincipal)
            .subscribe(appPrincipalStore => {
                this.plId = appPrincipalStore.classicRuntimeData.plId;
                this.tutorialLang = (this.plId === '29') ? appPrincipalStore.language : 'en';
            });
        location.onPopState(() => {
            introJs().exit()
        })
    }

    ngOnInit() {
        if(this.tutorialLang) {
            this.translateService.use(this.tutorialLang);
            this.translateService.get("firstTimeUserTutorials.stepsDefinition").subscribe((res: any) => {
                this.tutorialTranslation = res;
                this.onDefinedLanguage(this.tutorialLang);
            });
        }
        this.helpMenuService.selectTutorial().subscribe(res => {
            res.allTutorials.map(tutorial => {
                if((tutorial.tutorialName === this.currentPageTutorialName) && (tutorial.ifEventToStartTutorial)) {
                    this.onTutorialStart();
                }
                return tutorial;
            });
        });
    }

    ngOnChanges() {
        this.helpMenuService.setNotificationIfWLHasVehicles(this.ifWLHasVehicles).subscribe(v => v);
    }

    onTutorialStart() {
        this.introJSFn();
    }

    onTutorialsComplete(completedTutorials: string[]) {
        this.completedTutorials = completedTutorials;
        this.tutorialStateObject = Object.assign({}, this.tutorialStateObject,{
            tutorialsCompleted: completedTutorials
        });
        this.tutorialState.next(this.tutorialStateObject);
        this.helpMenuService.doneTutorials(completedTutorials)
            .subscribe(res=> res);
    }

    onTutorialSkipped() {
        this.tutorialStateObject = Object.assign({},this.tutorialStateObject, {
            isTutorialEscaped: true
        });
        this.tutorialState.next(this.tutorialStateObject);
    }

    onDefinedLanguage(lang) {
        this.tutorialStateObject = Object.assign({}, this.tutorialStateObject,{
            language: lang
        });
        this.tutorialState.next(this.tutorialStateObject);
    }

    introJSFn() {
        let intro = introJs();
        intro.setOptions({
            exitOnOverlayClick: false,
            nextLabel: this.tutorialTranslation.nextLabel,
            prevLabel: this.tutorialTranslation.prevLabel,
            skipLabel: this.tutorialTranslation.skipLabel,
            doneLabel:  this.tutorialTranslation.doneLabel,
            disableInteraction: true,
            steps: [
                {
                    element: '#filter-wl',
                    intro: `<h4 data-a8n="tutorial-wl-filter-title">${this.tutorialTranslation.steps.filter.title}</h4>
                            <p>${this.tutorialTranslation.steps.filter.annotation}</p>`
                },
                {
                    element: '#sort-wl',
                    intro: `<h4 data-a8n="tutorial-wl-sorting-title">${this.tutorialTranslation.steps.sorting.title}</h4>
                            <p>${this.tutorialTranslation.steps.sorting.annotation}</p>`,
                    position: 'bottom'
                },
                {
                    element: '#wl-vehicle-list',
                    intro: `<h4 data-a8n="tutorial-wl-vehicle-list-title">${this.tutorialTranslation.steps.vehicleList.title}</h4>
                            <p>${this.tutorialTranslation.steps.vehicleList.annotation}</p>`,
                    position: 'top'
                },
                {
                    element: '#wl-vehicle-list-db-rl',
                    intro: `<h4 data-a8n="tutorial-wl-bid-buy-title">${this.tutorialTranslation.steps.biddingAndBuying.title}</h4>
                            <p>${this.tutorialTranslation.steps.biddingAndBuying.annotation}</p>
                            <p>${this.tutorialTranslation.steps.biddingAndBuying.annotationAddition}</p>`,
                    position: 'top'
                },
                {
                    element: '#step5',
                    intro: `<h4 data-a8n="tutorial-wl-finish-tutorial-title">${this.tutorialTranslation.steps.finishTutorial.title}</h4>
                            <p>${this.tutorialTranslation.steps.finishTutorial.annotation}</p>`,
                    position: 'top'
                }
            ]
        })
        .start()
        .onexit(() => {
            this.onTutorialSkipped();
        })
        .oncomplete(() => {
            this.onTutorialsComplete(['watchlist']);
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/components-v1/first-time-wl-user-tutorials-v1/first-time-wl-user-tutorials-v1.component.ts